/**
 * Thin PostHog wrapper. Wired here so we have exactly one call site for
 * event capture and a documented list of what we track.
 *
 * BragBox's core funnel events (2026-04-18 CRO baseline):
 *   - `offer_page_viewed`     : /performance-review-rescue rendered
 *   - `checkout_clicked`      : any CTA to Payhip / Stripe fired
 *   - `signup_started`        : Login page in sign-up mode, email entered
 *   - `signup_completed`      : 201 from /api/auth/signup
 *   - `checkout_completed`    : success page acknowledges paid session
 *
 * All other ad-hoc events should still use this wrapper so they funnel
 * through the same `posthog` guard.
 */

function safePosthog() {
  if (typeof window === 'undefined') return null
  return window.posthog || null
}

export function trackEvent(event, properties) {
  try {
    const ph = safePosthog()
    if (!ph || typeof ph.capture !== 'function') return
    ph.capture(event, properties || {})
  } catch (err) {
    // Never let analytics break the app.
    // eslint-disable-next-line no-console
    if (process.env.NODE_ENV === 'development') {
      console.warn('analytics.trackEvent error', err)
    }
  }
}

export function identifyUser(userId, properties) {
  try {
    const ph = safePosthog()
    if (!ph || typeof ph.identify !== 'function') return
    ph.identify(userId, properties || {})
  } catch (err) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn('analytics.identifyUser error', err)
    }
  }
}

export function resetAnalytics() {
  try {
    const ph = safePosthog()
    if (!ph || typeof ph.reset !== 'function') return
    ph.reset()
  } catch (_) {
    /* noop */
  }
}

// Named events for type-safety-ish across the app.
export const EVENTS = Object.freeze({
  OFFER_PAGE_VIEWED: 'offer_page_viewed',
  CHECKOUT_CLICKED: 'checkout_clicked',
  CHECKOUT_COMPLETED: 'checkout_completed',
  SIGNUP_STARTED: 'signup_started',
  SIGNUP_COMPLETED: 'signup_completed',
})
